import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Common";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", { session_id: sid })
      .then(({ data }) => {
        setUser(data);
        const next = sessionStorage.getItem("mdp_next") || "/";
        sessionStorage.removeItem("mdp_next");
        navigate(next, { replace: true });
      })
      .catch(() => navigate("/accedi", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return <Loader text="Accesso in corso…" />;
}
